<ng-container #inner></ng-container>

<small class="required-error" *ngIf="required && !fieldModel?.isSuitableValue(value)">
  <span i18n>Value is required</span>
</small>
